import { Box } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
// import fire from '../../Info/assets/Group 1432.svg';
import { textDateFormatter } from '../Reusables';
import moment from 'moment';
// import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { useMutation, useQueryClient } from 'react-query';
import { postReadNotification } from '../../api/notifications';

import peopleIcon from '../../common/images/Layer 2 (1).svg';
// import payrollIcon from '../../common/images/Layer 2 (2).svg';
// import assetIcon from '../../common/images/Layer 2 (3).svg';
// import timeIcon from '../../common/images/Group 20.png';
import vehicleIcon from '../../common/images/Layer 2 (4).svg';
// import accountingIcon from '../../common/images/Layer 2.svg';

const NotificationComponent = ({ name, closeModal, bgColor, icon, item }) => {
  const queryClient = useQueryClient();
  const readNotification = useMutation(postReadNotification, {
    onSuccess: () => {
      queryClient.invalidateQueries('unread_count');
    }
  });
  const icons = {
    'timeoff-request': peopleIcon,
    'timeoff-request-approval': peopleIcon,
    'timeoff-request-dismissal': peopleIcon,
    birthday: peopleIcon,
    'work-anniversary': peopleIcon,
    'vehicle-service-reminder': vehicleIcon,
    business_user_accept_invitation: peopleIcon,
    employee_accept_invitation: peopleIcon
  };

  const SubText = {
    'timeoff-request': `${item.data?.employee_first_name} requested for ${item?.data?.days} day(s) ${item?.data?.timeoff_policy_title}`,
    'timeoff-request-dismissal': `Your time off request for ${item?.data?.timeoff_policy_title} has been declined`,
    'timeoff-request-approval': `Your time off request for ${item?.data?.timeoff_policy_title} has been approved`,
    birthday: `Wish ${
      item.data?.employee_first_name
    } a happy birthday (${convertTime(item.data.date)})`,
    'work-anniversary': `Congratulate ${item.data?.employee_first_name} for ${item.data?.num_years_spent} year(s) work anniversary`,
    'vehicle-service-reminder': `${item.data?.vehicle_make_name} ${item.data?.vehicle_model_name} is due for servicing in ${item.data?.weeks} week(s) `,
    business_user_accept_invitation: ` ${item.data?.email} has accepted ${item.data?.company_name} Bizedge business account`,
    employee_accept_invitation: `${item.data?.employee_first_name} has joined ${item.data?.company_name} `
  };
  function convertTime(date) {
    return moment.utc(date).format('HH:mm');
  }

  const eventHandlers = {
    timeoff_request: `/hr?type=all-employees&tab=all-employee-time-off&timeoff=Request`,
    // timeoff_request_rejection: '',
    employee_birthday: 'Employee Birthday',
    job_anniversary: 'Job Anniversary',
    vehicle_service_reminder: `/fleet/home/${item.data?.vehicle}?tab=maintenance`
  };

  function handleTimeoff() {
    readNotification.mutateAsync(item.id).then((res) => res);
    closeModal();
  }

  return (
    <NotificationComponent.Wrapper>
      <Link to={eventHandlers[name]}>
        <Box className='container' onClick={handleTimeoff}>
          {icon && <img src={icons[name]} alt='icons' />}
          <Box className='text'>
            <Box
              display='flex'
              justifyContent='space-between'
              alignItems='center'
              m='0'
            >
              <div className='heading'>{SubText[name]} </div>
            </Box>
            <div className='sub'>
              {' '}
              {textDateFormatter(item.created_at)}{' '}
              {convertTime(item.created_at)}
            </div>
            {name === 'timeoff-request' && (
              <Box id='cta'>
                <div className='approve'>Approve</div>
                <div className='reject'>Decline </div>
              </Box>
            )}
          </Box>
        </Box>
      </Link>
    </NotificationComponent.Wrapper>
  );
};

export default NotificationComponent;
NotificationComponent.Wrapper = styled(Box)`
  margin: 0 33px;
  a {
    text-decoration: none;
  }
  .container {
    display: flex;
    margin: 0.5rem 0 0.5rem 0;
    padding: 10px;
    cursor: pointer;
    border-bottom: 1px solid #e1e1e1;
    border-radius: 5px;
    .text {
      margin-left: 1rem;
      width: 100%;
      .heading {
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 137.86%;
        color: #545454;
      }
      .sub {
        font-weight: 400;
        font-size: 12px;
        line-height: 137.86%;
        color: #545454;
        margin-top: 5px;
      }
    }
  }

  #cta {
    display: flex;
    gap: 7px;
    margin-top: 4px;
    div {
      font-weight: 400;
      font-size: 10px;
      line-height: 137.86%;
      padding: 4px 6px;
      cursor: pointer;
    }
    .approve {
      color: #2898a4;
      background: #eaf8fa;
      border-radius: 3px;
    }
    .reject {
      color: #878787;
      background: #f2f2f2;
      border-radius: 3px;
    }
  }
`;
